import { getInfo } from '@Components/Grid/components/Table/formatters';
import { formatDate } from 'utils';

export default function DateFormatter({ info }) {
  const { value } = getInfo(info)

  if (!value) {
    return '--'
  }

  return <>
    {formatDate(value, 'MMM DD, YYYY')}
  </>
}
